import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as config from "../../../constants/config";
import * as methods from "../../../constants/methods";
import * as keyCodes from "../../../constants/keyCodes";
import * as rcc from "../../../constants/rcc";
import * as resources from "../../../constants/resources";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgMax from "../../../resources/img/svgicons/max-fill.svg";
import imgAdd from "../../../resources/img/svgicons/add-colorant.svg";
import imgOverfill from "../../../resources/img/svgicons/over-fill.svg";
import Modal from "../generic/Modal";
import Input from "../generic/Input";
import Table, {TABLE_VARIANT_SECONDARY} from "../generic/Table";
import Button from "../generic/Button";

export default class CanisterLevelsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeCanisterId: null,
            currentLevelInput: "",
            addLevelInput: "0"
        };
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.canisterList !== this.props.canisterList &&
            this.props.canisterList.find((canister) => canister.id === this.state.activeCanisterId)
        ) {
            this.setState({
                currentLevelInput: String(
                    this.props.canisterList.find((canister) => canister.id === this.state.activeCanisterId).currentLevel
                )
            });
        }
    }

    getCanisterById = (id) => {
        for (let canister of this.props.canisterList) {
            if (canister.id === id) {
                return canister;
            }
        }

        return null;
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleInputFocus = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister !== null) {
            this.setState({
                activeCanisterId: canister.id,
                currentLevelInput: String(canister.currentLevel),
                addLevelInput: "0"
            });

            event.target.select();
        }
    };

    handleCurrentLevelInputKeyDown = (event) => {
        if (event.keyCode === keyCodes.ENTER) {
            event.preventDefault();
            event.target.blur();
        }
    };

    handleCurrentLevelInputChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({currentLevelInput: event.target.value});
        }
    };

    handleCurrentLevelInputBlur = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister !== null) {
            if (validationHelper.isDecimalValueValid(event.target.value)) {
                let level = Number(event.target.value);

                if (level >= 0 && level <= canister.capacity && level !== canister.currentLevel) {
                    this.props.confirmCanisterRefill(
                        canister.id,
                        level,
                        false,
                        false,
                        rcc.RCC_REFILL_MANUAL_CORRECTION
                    );
                }
            }

            this.setState({
                currentLevelInput: String(canister.currentLevel)
            });
        } else {
            this.setState({
                currentLevelInput: ""
            });
        }
    };

    handleAddCanisterLevelChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({addLevelInput: event.target.value});
        }
    };

    handleAddLevelClick = (event) => {
        if (validationHelper.isDecimalValueValid(this.state.addLevelInput)) {
            let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

            if (canister !== null) {
                let level = Number(validationHelper.formatDecimal(this.state.addLevelInput));

                if (level > 0 && canister.currentLevel + level <= canister.capacity) {
                    this.props.confirmCanisterRefill(canister.id, level, true, false);
                }
            }
        }
    };

    handleSetMaxLevelClick = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister !== null && canister.currentLevel < canister.capacity) {
            this.props.confirmCanisterRefill(canister.id, canister.capacity, false, false);
        }
    };

    handleRefillCanisterClick = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister !== null) {
            this.props.startCanisterRefill(canister.id);
        }
    };

    handleColorantMoveTableToRefillClick = (event) => {
        if (
            this.props.machine.isConnected &&
            this.props.machine.validMethod(methods.METHOD_MACHINE_MOVE_TABLE_TO_REFILL) &&
            this.props.machine.validDevice(rcc.MACHINE_DEVICE_MOVABLE_TABLE)
        ) {
            this.props.moveTableToRefill(Number(event.currentTarget.dataset.id));
        }
    };

    getAddLevelButton = (canister) => {
        let level = Number(validationHelper.formatDecimal(this.state.addLevelInput));
        if (
            canister.id !== this.state.activeCanisterId ||
            level === 0 ||
            canister.currentLevel + level > canister.capacity
        ) {
            return (
                <Button
                    className="padding-none"
                    disabled
                    svgBefore={imgAdd}
                    tooltipText={translate(
                        canister.currentLevel + level > canister.capacity
                            ? "canistersTab.refillOverLimit"
                            : "canistersTab.refillNoAmount"
                    )}
                />
            );
        }

        return (
            <Button
                className="padding-none"
                elementProps={{
                    "data-id": canister.id
                }}
                svgBefore={imgAdd}
                onClick={this.handleAddLevelClick}
                tooltipText={this.props.rccUnit}
            />
        );
    };

    getAddLevelInput = (canister) => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_ADD_CANISTER_LEVEL)) {
            return "";
        }

        return (
            <div className="col-12 flex flex-wrap flex-align-center-horizontal">
                <Input
                    className="primary-input col-7"
                    type="text"
                    elementProps={{
                        "data-id": canister.id
                    }}
                    value={canister.id === this.state.activeCanisterId ? this.state.addLevelInput : "0"}
                    onFocus={this.handleInputFocus}
                    onChange={this.handleAddCanisterLevelChange}
                />
                {this.getAddLevelButton(canister)}
            </div>
        );
    };

    getFillCanisterToMaxButton = (canister) => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_FILL_CANISTER_TO_MAX)) {
            return "";
        }

        if (canister !== null && canister.currentLevel < canister.capacity) {
            return (
                <div className="flex flex-align-center-horizontal col-12">
                    <Button
                        className="padding-none padding-left-5 padding-right-5"
                        svgBefore={imgMax}
                        elementProps={{"data-id": canister.id}}
                        onClick={this.handleSetMaxLevelClick}
                    />
                </div>
            );
        }

        return (
            <div className="flex flex-align-center-horizontal col-12">
                <Button className="padding-none padding-left-5 padding-right-5" disabled svgBefore={imgMax} />
            </div>
        );
    };

    getRefillCanisterButton = (canister) => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_TRIGGER_REFILL_DIALOG)) {
            return "";
        }

        if (canister !== null && canister.currentLevel < canister.capacity) {
            return (
                <div className="flex flex-align-center-horizontal col-12">
                    <Button
                        className="padding-none padding-left-5 padding-right-5"
                        elementProps={{
                            "data-id": canister.id
                        }}
                        onClick={this.handleRefillCanisterClick}
                        svgBefore={imgOverfill}
                    />
                </div>
            );
        }

        return (
            <div className="flex flex-align-center-horizontal col-12">
                <Button disabled className="padding-none padding-left-5 padding-right-5" svgBefore={imgOverfill} />
            </div>
        );
    };

    getCurrentLevelInput = (canister) => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_SET_CANISTER_LEVEL)) {
            return (
                <React.Fragment>
                    <div className="">{canister.currentLevel}</div>
                    <div>{this.props.rccUnit}</div>
                </React.Fragment>
            );
        }

        return (
            <div className="flex flex-wrap flex-align-center-vertical">
                <Input
                    type="text"
                    className="primary-input col-10"
                    value={
                        canister.id === this.state.activeCanisterId
                            ? this.state.currentLevelInput
                            : canister.currentLevel
                    }
                    elementProps={{"data-id": canister.id}}
                    onFocus={this.handleInputFocus}
                    onKeyDown={this.handleCurrentLevelInputKeyDown}
                    onChange={this.handleCurrentLevelInputChange}
                    onBlur={this.handleCurrentLevelInputBlur}
                />
                <div className="col-2">{this.props.rccUnit}</div>
            </div>
        );
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow(
            [
                modelHelper.buildTableCell(<Translate value="" />, "font-size-0_75em text-align-center"),
                modelHelper.buildTableCell(
                    <Translate value="general.maxLevel" />,
                    "font-size-0_75em text-align-center"
                ),
                modelHelper.buildTableCell(<Translate value="general.warning" />, "font-size-0_75em text-align-center"),
                modelHelper.buildTableCell(<Translate value="general.minimum" />, "font-size-0_75em text-align-center"),
                modelHelper.buildTableCell(
                    <Translate value="general.actualLevel" />,
                    "font-size-0_75em text-align-center"
                ),
                modelHelper.buildTableCell(<Translate value="general.add" />, "font-size-0_75em text-align-center"),
                modelHelper.buildTableCell(
                    <Translate value="canisterLevel.fillToMax" />,
                    "font-size-0_75em text-align-center"
                ),
                modelHelper.buildTableCell(<Translate value="general.refill" />, "font-size-0_75em text-align-center")
            ],
            "flex-space-between"
        );
    };

    getTableRows = (canisters, type) => {
        return canisters
            .filter((canister) => canister.colorant !== null)
            .map((canister) => {
                return modelHelper.buildTableRow(
                    [
                        modelHelper.buildTableCell(
                            <div className="font-size-1_5em flex flex-align-start">
                                <div
                                    className="color-square"
                                    style={{
                                        backgroundColor:
                                            canister.colorant.rgb === null ? config.DEFAULT_RGB : canister.colorant.rgb
                                    }}
                                />
                                <div
                                    className="cursor-pointer"
                                    data-id={canister.id}
                                    onDoubleClick={this.handleColorantMoveTableToRefillClick}
                                >
                                    {canister.colorant.name}
                                </div>
                            </div>
                        ),

                        modelHelper.buildTableCell(
                            <React.Fragment>
                                <div className="">
                                    {canister.capacity} {this.props.rccUnit}
                                </div>
                            </React.Fragment>,
                            "cell-lighter padding-bottom-5 padding-top-5"
                        ),
                        modelHelper.buildTableCell(
                            <React.Fragment>
                                <div className="">
                                    {canister.warningLevel} {this.props.rccUnit}
                                </div>
                            </React.Fragment>,
                            "cell-lighter padding-bottom-5 padding-top-5"
                        ),
                        modelHelper.buildTableCell(
                            <React.Fragment>
                                <div className="">
                                    {canister.minimumLevel} {this.props.rccUnit}
                                </div>
                            </React.Fragment>,
                            "cell-lighter padding-bottom-5 padding-top-5"
                        ),
                        modelHelper.buildTableCell(this.getCurrentLevelInput(canister)),
                        modelHelper.buildTableCell(this.getAddLevelInput(canister)),
                        modelHelper.buildTableCell(this.getFillCanisterToMaxButton(canister)),
                        modelHelper.buildTableCell(this.getRefillCanisterButton(canister))
                    ],
                    "flex-space-between text-align-center flex-align-center-vertical " +
                        (type === "error" ? "background-error" : type === "warning" ? "background-warning" : "")
                );
            });
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-2"),
            modelHelper.buildTableColumn("col-1"),
            modelHelper.buildTableColumn("col-1"),
            modelHelper.buildTableColumn("col-1"),
            modelHelper.buildTableColumn("col-1"),
            modelHelper.buildTableColumn("col-2"),
            modelHelper.buildTableColumn("col-1"),
            modelHelper.buildTableColumn("col-1")
        ];
    };

    getCriticalCanistersTable = (canisters) => {
        if (canisters.length === 0) {
            return "";
        }

        return (
            <div className="padding-bottom-10 margin-bottom-10 col-12 std-border-bottom">
                <Translate className="font-size-1_5em color-red" value="canisterLevel.criticalLevelCanister" />
                <Table
                    variant={TABLE_VARIANT_SECONDARY}
                    className="flex-child fill-flex-space col-12"
                    tableHeader={this.getTableHeader()}
                    tableRows={this.getTableRows(canisters, "error")}
                    tableColumns={this.getTableColumns()}
                />
            </div>
        );
    };

    getWarningCanistersTable = (canisters) => {
        if (canisters.length === 0) {
            return "";
        }

        return (
            <div className="padding-bottom-10 margin-bottom-10 std-border-bottom">
                <Translate className="font-size-1_5em color-warning" value="canisterLevel.warningLevelCanister" />
                <Table
                    variant={TABLE_VARIANT_SECONDARY}
                    className="col-12"
                    tableHeader={this.getTableHeader()}
                    tableRows={this.getTableRows(canisters, "warning")}
                    tableColumns={this.getTableColumns()}
                />
            </div>
        );
    };

    getOtherCanistersTable = (canisters) => {
        if (canisters.length === 0) {
            return "";
        }

        return (
            <React.Fragment>
                <Translate className="font-size-1_5em" value="canisterLevel.otherCanisters" />
                <Table
                    variant={TABLE_VARIANT_SECONDARY}
                    className="col-12"
                    tableHeader={this.getTableHeader()}
                    tableRows={this.getTableRows(canisters)}
                    tableColumns={this.getTableColumns()}
                />
            </React.Fragment>
        );
    };

    getNoCanistersMessage = () => {
        if (this.props.canisterList.length === 0) {
            return (
                <div className="no-available">
                    <Translate value="machineSettings.machineConfigurationNoCanisters" />
                </div>
            );
        }

        return "";
    };

    getContent = (criticalLevelCanisters, warningLevelCanisters, otherCanisters) => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12">{this.getCriticalCanistersTable(criticalLevelCanisters)}</div>
                <div className="col-12">{this.getWarningCanistersTable(warningLevelCanisters)}</div>
                <div className="col-12">{this.getOtherCanistersTable(otherCanisters)}</div>
                {this.getNoCanistersMessage()}
            </React.Fragment>,
            "col-12 flex flex-wrap slim-scroll"
        );
    };

    render() {
        let criticalLevelCanisters = [];
        let warningLevelCanisters = [];
        let otherCanisters = [];
        let canister;

        for (canister of this.props.canisterList) {
            if (canister.currentLevel < canister.minimumLevel) {
                criticalLevelCanisters.push(canister);
            }
            if (canister.currentLevel >= canister.minimumLevel && canister.currentLevel < canister.warningLevel) {
                warningLevelCanisters.push(canister);
            }
            if (canister.currentLevel >= canister.warningLevel) {
                otherCanisters.push(canister);
            }
        }

        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="canisterLevel.canisterLevel" />)}
                content={this.getContent(criticalLevelCanisters, warningLevelCanisters, otherCanisters)}
                styles={{minWidth: "80%"}}
            />
        );
    }
}
